"use strict";

var _slicedToArray = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@netgum/utils");

var rxjs_1 = require("rxjs");

var operators_1 = require("rxjs/operators");

var rxjs_addons_1 = require("rxjs-addons");

var Url = /*#__PURE__*/function () {
  function Url(options, adapter, action, eth) {
    _classCallCheck(this, Url);

    this.options = options;
    this.adapter = adapter;
    this.action = action;
    this.eth = eth;
    this.incoming$ = new rxjs_addons_1.UniqueBehaviorSubject(null);
    this.outgoing$ = new rxjs_1.Subject(); //
  }

  _createClass(Url, [{
    key: "setup",
    value: function setup() {
      var _this = this;

      var result = [this.incoming$.pipe(operators_1.map(function (url) {
        return _this.urlToAction(url);
      }), operators_1.filter(function (action) {
        return !!action;
      }), operators_1.tap(function () {
        _this.incoming$.next(null);
      })).subscribe(this.action.$incoming)];

      if (this.adapter) {
        var active = true;

        var listener = function listener(url) {
          if (active) {
            _this.incoming$.next(url || null);
          }
        };

        this.adapter.addListener(listener);
        var subscription = this.outgoing$.pipe(operators_1.filter(function (url) {
          return !!url;
        })).subscribe(function (url) {
          return _this.adapter.open(url);
        });
        var unsubscribe = subscription.unsubscribe.bind(subscription);

        subscription.unsubscribe = function () {
          active = false;

          if (_this.adapter.removeListener) {
            _this.adapter.removeListener(listener);
          }

          unsubscribe();
        };

        result.push(subscription);
      }

      return result;
    }
  }, {
    key: "buildActionUrl",
    value: function buildActionUrl(action) {
      var endpoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!endpoint) {
        endpoint = this.options && this.options.endpoint ? this.options.endpoint : Url.DEFAULT_ENDPOINT;
      }

      return this.actionToUrl(action, endpoint);
    }
  }, {
    key: "openActionUrl",
    value: function openActionUrl(action) {
      var endpoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var url = this.buildActionUrl(action, endpoint);
      this.outgoing$.next(url);
    }
  }, {
    key: "urlToAction",
    value: function urlToAction(url) {
      var result = null;

      if (url) {
        try {
          var _url$split = url.split("".concat(Url.QUERY_FIELD_NAME, "=")),
              _url$split2 = _slicedToArray(_url$split, 2),
              raw = _url$split2[1];

          var _raw$split = raw.split('&');

          var _raw$split2 = _slicedToArray(_raw$split, 1);

          raw = _raw$split2[0];

          if (raw) {
            var payload = JSON.parse(decodeURIComponent(raw), utils_1.jsonReviver);

            if (payload.action && payload.networkId === this.eth.getNetworkId()) {
              result = payload.action;
            }
          }
        } catch (err) {
          result = null;
        }
      }

      return result;
    }
  }, {
    key: "actionToUrl",
    value: function actionToUrl(action, endpoint) {
      var result = null;

      if (action && endpoint) {
        try {
          result = endpoint;

          if (result.includes('?')) {
            if (!result.endsWith('?')) {
              result = "".concat(result, "&");
            }
          } else {
            result = "".concat(result, "?");
          }

          var payload = {
            action: action,
            networkId: this.eth.getNetworkId()
          };
          result = "".concat(result).concat(Url.QUERY_FIELD_NAME, "=").concat(encodeURIComponent(JSON.stringify(payload, utils_1.jsonReplacer)));
        } catch (err) {
          result = null;
        }
      }

      return result;
    }
  }]);

  return Url;
}();

Url.QUERY_FIELD_NAME = 'asq';
Url.DEFAULT_ENDPOINT = '://';
exports.Url = Url;